import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { EventService } from '../../core/services/event.service';
import * as _ from "lodash";
import {Angulartics2} from "angulartics2";

@Component({
    selector: 'insurance-tab',
    templateUrl: './insurance.tab.html',
    styleUrls: ['./profile.page.scss']
})

export class InsuranceTab implements AfterViewInit, OnInit {
    @Output() onInit = new EventEmitter();
    @ViewChild('f', { static: true }) form;

    originalModel: any;
    model: any;
    state: any = {
        isSubmitted: false
    };

    constructor(private eventService: EventService,
                private http: HttpClient,
                private toastr: ToastrService,
                private angulartics2: Angulartics2) {}

    ngOnInit() {
        this.convertToModels(this.eventService.selectedEvent.gql);
        this.eventService.onEventChange.subscribe(event => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
        this.eventService.onGqlReload.subscribe(() => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
        this.angulartics2.eventTrack.next({
            action: 'View Insurance',
            properties: {category: 'Profile'}
        });
    }

    ngAfterViewInit() {
        this.onInit.emit(this.form);
    }

    convertToModels(gqlRes) {
        this.model = {};
        if (!gqlRes) return;
        let constituent = gqlRes.Participant[0].individualConstituent;
        this.model = {
            insuranceCompany: constituent.insuranceCompany,
            currentMedications: constituent.currentMedications,
            currentMedicalConditions: constituent.currentMedicalConditions,
            allergies: constituent.allergies
        };
        this.originalModel = _.clone(this.model);
    }

    cancel() {
        this.model = _.clone(this.originalModel);
        this.state.isSubmitted = false;
    }

    save() {
        this.state.isSubmitted = true;
        if (!this.form.valid) return;
        this.http.post('/api/v1/user/insurance', this.model)
            .subscribe(res => {
                this.form.form.markAsPristine();
                this.eventService.getInsuranceDetails(true).subscribe(() => {});
                this.toastr.success('Insurance & Health information updated.');
                this.angulartics2.eventTrack.next({
                    action: 'Edit Insurance',
                    properties: {category: 'Profile'}
                });
            }, err => {
                this.toastr.error("There was a problem updating the Insurance & Health information");
            });
        this.originalModel = _.clone(this.model);
        this.state.isSubmitted = false;
    }
}

